import { post, get, postJson  } from '../api/axios2'
import { decryptBatch } from "@/api/jhk/integralCenter/freeGift";
const decryptBatchObj = {
  async decrypt(p) {
    return await decryptBatch(p)
  },
}

export default decryptBatchObj